import { useLazyQuery } from "@apollo/client/react";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CardBox from "../../CardBox/CardBox";
import { Grid } from "@mui/material";
import InfoRow from "../../InfoRow/InfoRow";

import { GET_INFO_ASISTENCIAL_VISITA, parseInfoAsistencial } from "../../../../../../data/graphQL/queries/MisVisitas/getInfoAsistencial";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../../../components/customButton/CustomButton";
import GET_LAST_VISITA_MEDICA, { adaptLastVisita } from "../../../../../../data/graphQL/queries/MisVisitas/getLastVisitaMedica";
import { idTiposProfesionales } from "../../../../constants/tiposProfesionales";

export default function DatosAsistencialesGenerales({ readOnly, visita, setVisita, idEvaluacion, idTipoProfesional, figuraProfesional }) {
  const esEspecialistaOConsultor = ["ESPECIALISTA", "CONSULTOR"].includes(figuraProfesional?.trim()?.toUpperCase());
  const navigate = useNavigate();
  const [lastVisita, setLastVisita] = useState(null);

  const [getDatosAsistenciales, { data: dataInfoAsistencialVisita }] = useLazyQuery(GET_INFO_ASISTENCIAL_VISITA);

  const isOtroProfesional = useMemo(() => {
    return idTipoProfesional == idTiposProfesionales.KINESIOLOGO ||
      idTipoProfesional == idTiposProfesionales.PSICOLOGO ||
      idTipoProfesional == idTiposProfesionales.PSIQUIATRA ||
      idTipoProfesional == idTiposProfesionales.TERAPISTA_OCUPACIONAL ||
      idTipoProfesional == idTiposProfesionales.ASISTENTE_SOCIAL ||
      idTipoProfesional == idTiposProfesionales.REHABILITADOR;
  }, [idTipoProfesional]);

  useEffect(() => {
    if (!dataInfoAsistencialVisita) return;
    if (!!dataInfoAsistencialVisita?.informacionAsistencialVisita?.valorEsperado) {
      setVisita((prev) => ({
        ...prev,
        ...parseInfoAsistencial(dataInfoAsistencialVisita)
      }));
    }
  }, [dataInfoAsistencialVisita]);

  const [getLastVisita, { data: dataLastVisitaMedica }] = useLazyQuery(GET_LAST_VISITA_MEDICA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataLastVisitaMedica) return;
    setLastVisita(adaptLastVisita(dataLastVisitaMedica));
  }, [dataLastVisitaMedica]);

  useEffect(() => {
    if (!idEvaluacion) return;
    getDatosAsistenciales({ variables: { idEvaluacion } });
  }, [idEvaluacion]);

  useEffect(() => {
    if (!idEvaluacion || !esEspecialistaOConsultor) return;
    getLastVisita({ variables: { idEvaluacion } });
  }, [idEvaluacion, esEspecialistaOConsultor]);

  const handleViewLastVisita = () => {
    navigate('/misVisitas/nuevaVisita', {
      state: {
        isNew: false,
        onlyView: true,
        idVisita: lastVisita?.idVisita,
        idPaciente: lastVisita?.idPaciente,
        idProfesional: lastVisita?.idProfesional,
        idTipoProfesional: lastVisita?.idTipoProfesional,
        idFuncionProfesional: lastVisita?.idFuncionProfesional,
        idEvaluacion: lastVisita?.idEvaluacion,
        idTipoModulo: lastVisita?.idTipoModulo,
        idFrecuencia: lastVisita?.idFrecuencia,
        programa: lastVisita?.programa,
        idTipoVisita: lastVisita?.idTipoVisita,
        visitasProgramadas: lastVisita?.visitasProgramadas,
        periodo: lastVisita?.periodo
      }
    });
  };

 const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      switch (input.name) {
        case 'requiereCapacitacion':
          newInput.hidden = isOtroProfesional || (idTipoProfesional !== 2 && idTipoProfesional !== 7);
          break;
      }

      return newInput;
    });
  }, [isOtroProfesional, idTipoProfesional]
  );

  return (
    <CardBox>
      <Grid container spacing={1}>
        {formattedInputs.filter((inp) => !inp.hidden)
          .map((input) => {
            return <>
              {
                input.name != 'botonVerVisita' &&
                <InfoRow
                  key={input.name}
                  label={input.displayName}
                  value={visita[input.name] ?? '-'}
                />
              }
              {
                input.name == 'botonVerVisita' && esEspecialistaOConsultor &&
                <CustomButton
                  sx={{ mt: 2 }}
                  onClick={() => handleViewLastVisita()}
                  size='medium'
                  variant='outlined'
                  disabled={readOnly}>

                  {input.displayName}
                </CustomButton>

              }
            </>;
          })}
      </Grid>
    </CardBox>);

}

const inputs = [
  { name: "diagnostico", displayName: "Diagnóstico" },
  { name: "enfermedadOncologica", displayName: "Enf. que motiva el soporte es oncologica" },
  { name: "pesoActual", displayName: "Peso" },
  { name: "talla", displayName: "Talla" },
  { name: "gradoDesnutricion", displayName: "Grado de desnutrición" },
  { name: "diagnosticoNutricional", displayName: "Diagnóstico nutricional" },
  { name: "soporteNutricional", displayName: "Meta del soporte nutricional" },
  { name: "fase", displayName: "Fase" },
  { name: "requiereCapacitacion", displayName: "Requiere Capacitación" },
  { name: "botonVerVisita", displayName: "Ver ultima visita medica" }];